import {GroupAttitude} from "../../store/model/group.ts";
import {Typography, TypographyProps} from "@mui/material";

export function GroupAttitudeView({ attitude, ...props }: { attitude: GroupAttitude } & Omit<TypographyProps, "children">) {
  return (
    <Typography {...props}>{[attitude.attitude1, attitude.attitude2, attitude.attitude3, attitude.attitude4, attitude.attitude5].join(", ")}</Typography>
  )
}